import React from "react";
import moment from "moment-timezone";
import VirtualScreeningIcon from "../icons/virtual-screening-icon.jsx";
import { GridTile } from "material-ui";
import { getColorForTag } from "../../../util";

class EventGridListItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hovered: false
    };

    this._onClick = this._onClick.bind(this);
  }

  static get contextTypes() {
    return {
      tenant: React.PropTypes.object,
      router: React.PropTypes.func
    };
  }

  _onClick() {
    this.context.router.push({
      pathname: `/schedule/${this.props.item.id}`,
      state: { fromSchedule: true }
    });
  }

  getStyles() {
    return {
      tile: {
        cursor: "pointer"
      },
      title: {
        padding: "0 10px"
      },
      virtualTitle: {
        padding: "0 10px",
        float: "left",
        width: "80%",
        overflow: "hidden",
        textOverflow: "ellipsis"
      },
      subtitle: {
        padding: "0 10px"
      },
      virtualSubtitle: {
        padding: "0 35px"
      },
      img: {
        transition: "all .2s ease-in-out"
      },
      imgHovered: {
        transform: "translateX(-50%) scale(1.1)"
      }
    };
  }

  render() {
    let styles = this.getStyles(),
      event = this.props.item;
    const start = moment(event.start_time);
    const includeYear = !start.isSame(moment(), "year");
    const dateFmt = includeYear
      ? "ddd, MMM Do, YYYY, LT z"
      : "ddd, MMM Do, LT z";

    return (
      <GridTile
        className="EventList--EventGridListItem"
        style={styles.tile}
        title={
          <div>
            {event.is_virtual ? (
              <div>
                <VirtualScreeningIcon
                  styles={{
                    float: "left",
                    marginBottom: -7
                  }}
                  rightAlign
                />
                <div
                  style={event.is_virtual ? styles.virtualTitle : styles.title}
                >
                  {event.name}
                </div>
              </div>
            ) : (
              <div
                style={event.is_virtual ? styles.virtualTitle : styles.title}
              >
                {event.name}
              </div>
            )}
          </div>
        }
        subtitle={
          event.is_dated ? (
            <div
              style={
                event.is_virtual ? styles.virtualSubtitle : styles.subtitle
              }
            >
            {start.format(dateFmt)}
            </div>
          ) : null
        }
        titleBackground="rgba(0,0,0,0.6)"
        onClick={this._onClick}
        onMouseEnter={() => this.setState({ hovered: true })}
        onMouseLeave={() => this.setState({ hovered: false })}
      >
        {event.images.cover ? (
          <img
            src={event.images.cover}
            style={Object.assign(
              {},
              styles.img,
              this.state.hovered && styles.imgHovered
            )}
          />
        ) : (
          <div
            style={{
              height: "100%",
              backgroundColor: getColorForTag(
                event.tags.length ? event.tags[0] : event.name,
                false,
                false,
                this.context.tenant
              )
            }}
          ></div>
        )}
      </GridTile>
    );
  }
}

export default EventGridListItem;



// WEBPACK FOOTER //
// ./src/app/components/partials/event-list/event-grid-list-item.jsx